import {
  all,
  fork,
  put,
  takeEvery,
  cancel,
  select,
  call,
  take,
  takeLatest,
} from "redux-saga/effects";
import isEmpty from "lodash.isempty";
import isNil from "lodash.isnil";
import { getCookie, getParameterByName, toCamelCase } from "helpers";
import {
  fetchUserInProject,
  fetchUserInProjectSuccess,
  setLabelerId,
} from "redux/members/action";
import { getShapes } from "redux/shape/actions";
import {
  setSourceInfo,
  setUserData,
  getModuleCode,
  loadRepoError,
  getModuleCodeError,
  getModuleCodeSuccess,
  fetchInitialDataSuccess,
  resetIsChangeCurrentDropdown,
  fetchDataCarCompaniesSuccess,
  fetchTargetLabelsSuccess,
  autoLabelSuccess,
  autoLabelFailure,
  getAuditLogsSuccess,
  getAuditLogsError,
} from "./actions";
import { selectPaginationByStatus } from "redux/image/selectors";
import {
  fetchImages,
  getRowIndexImageAPI,
  getTargetLabelsAPI,
  autoLabelApi,
} from "api/image";
import { fetchLabels } from "api/issues";
import { fetchDataCarCompaniesApi } from "api/carInfo";
import {
  FETCH_INPUT_DATA,
  SELECT_ONE_SOURCE_SUCCESS,
} from "redux/image/constants";
import { fetchLabelsSuccess } from "redux/points/actions";
import { FETCH_INITIAL_DATA } from "redux/app/constants";
import {
  setCurrentDropdownStatus,
  fetchInitialData,
  fetchDataCarCompanies,
} from "redux/app/actions";
import {
  selectLimit,
  selectImages,
  selectAllImgIds,
  selectFilterTags,
} from "redux/image/selectors";
import get from "lodash.get";
import {
  fetchInputDataSuccess,
  noMoreToFetch,
  resetStateImages,
  selectOneSource,
} from "redux/image/actions";
import { showNotification } from "redux/notification/actions";
import {
  selectDatasetId,
  selectProjectId,
  selectCustomerReview,
  selectSourceId,
} from "redux/app/selectors";
import { selectLabelerId, selectReviewerId } from "redux/members/selectors";
import { startChannel } from "redux/socket/actions";
import {
  LOAD_REPO,
  SET_SOURCE_INFO,
  GET_MODULE_CODE,
  FETCH_INITIAL_DATA_SUCCESS,
  SEND_EMAIL_TO_SYSTEM_ADMIN,
  FETCH_DATA_CAR_COMPANIES,
  AUTO_LABELS_REQUEST,
  GET_AUDIT_LOGS,
} from "./constants";
import { FETCH_USER_IN_PROJECT } from "redux/members/constants";
import { getRole, getUserInProject, getAuditLogsAPI } from "api";
import { sendEmailToSystemAdminAPI } from "api/configApp";
import { getPermission } from "redux/permission/actions";

function* watchLoadAppInfo() {
  yield takeEvery(LOAD_REPO, function* () {
    try {
      const tokenInCookie = getCookie("Bearer");
      const userInfoInCookie = getCookie("userInfo");
      const userId = userInfoInCookie
        ? JSON.parse(userInfoInCookie).userId
        : null;
      const projectId = getParameterByName("projectId");
      const datasetId = getParameterByName("datasetId");
      const sourceId = getParameterByName("sourceId");
      const checkLastActive = getParameterByName("checkLastActive");
      const customerReview = getParameterByName("customerReview");
      let sourceInfo = {
        projectId,
        datasetId,
        sourceId,
        checkLastActive,
        customerReview: customerReview ? JSON.parse(customerReview) : false,
      };

      if (
        !userInfoInCookie ||
        !userId ||
        !tokenInCookie ||
        !sourceInfo.projectId ||
        !sourceInfo.datasetId
      ) {
        yield put(
          loadRepoError({
            msg: "Error when fetching the repository.",
            msgId: "notification.error-fetching-repo",
          })
        );
        yield cancel();
      }

      yield put(
        getModuleCode({
          projectId: sourceInfo.projectId,
          userId,
          callback: function* getModuleCodeCallback(res) {
            if (res.status === 200 && res.success === true) {
              yield put(
                fetchUserInProject({ projectId: sourceInfo.projectId })
              );
              yield put(
                setSourceInfo({
                  ...sourceInfo,
                  checkLastActive: Boolean(checkLastActive),
                })
              );
              const camelCaseUserInfo = toCamelCase(
                JSON.parse(userInfoInCookie)
              );
              yield put(setUserData(camelCaseUserInfo));
              yield put(startChannel());
            }
          },
        })
      );
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log("load repo error", error);
      yield cancel();
    }
  });
}

function* watchGetModuleCode() {
  yield takeEvery(GET_MODULE_CODE, function* ({ payload }) {
    const { projectId, userId, callback } = payload;

    const response = yield call(getRole, { projectId, userId });
    if (callback) yield fork(callback, response);
    if (response.success) {
      const data = get(response, "data", []);
      const allowedModules = ["labeling", "customer", "point_issue"];
      const labelingModule = data.filter((module) =>
        allowedModules.some((allow) => module.includes(allow))
      );

      yield put(getModuleCodeSuccess(labelingModule));
    } else if (response.status === 403) {
      yield put(
        getModuleCodeError({
          msg: "Does not have permission to access this link.",
          msgId: "notification.does-not-have-permission-to-access-this-link",
        })
      );
    } else {
      yield put(
        getModuleCodeError({
          msg: "Error when fetching the repository.",
          msgId: "notification.error-fetching-repo",
        })
      );
    }
  });
}

function* watchUserData() {
  yield takeEvery(SET_SOURCE_INFO, function* () {
    const projectId = yield select(selectProjectId);
    const sourceId = yield select(selectSourceId);

    if (sourceId) {
      yield put(selectOneSource({ id: sourceId }));
    }
    const result = yield call(fetchLabels, projectId);
    const labels = get(result, "data", []);
    if (result.success && labels.length) {
      yield put(fetchLabelsSuccess(labels));
    } else {
      console.error(
        "No classes to fetch, please contact your project manager!"
      );
    }
  });
}

/** Chỉ bắt sự kiện 1 lần duy nhất */
function* watchFetchInputAndSelectOne() {
  const twoActions = yield all([take(SELECT_ONE_SOURCE_SUCCESS)]);
  const result = twoActions.find(
    (action) => action.type === SELECT_ONE_SOURCE_SUCCESS
  );

  const status = get(result, "payload.status", null);
  const sourceId = get(result, "payload.sourceId", null);
  const sendingStatus = Array.isArray(status) ? status.join(",") : status;

  if (status && sourceId) {
    const datasetId = yield select(selectDatasetId);
    const projectId = yield select(selectProjectId);
    const limit = yield select(selectLimit);

    const [record, targetLabelsRes] = yield all([
      call(getRowIndexImageAPI, {
        projectId,
        status: sendingStatus,
        datasetId,
        sourceId,
      }),
      call(getTargetLabelsAPI, { projectId }),
    ]);

    yield put(
      fetchInitialData({
        status,
        page:
          record?.data?.rowIndex % limit !== 0
            ? Math.floor(record?.data?.rowIndex / limit)
            : Math.floor(record?.data?.rowIndex / limit) - 1 ?? 0,
        isSelectOneSourceSuccess: true,
        isLoadData: true,
      })
    );

    // Fetch default valueMe carCompanies
    yield put(fetchDataCarCompanies());

    // Get permission matrix
    yield put(getPermission({ projectId, datasetId, sourceId }));

    yield put(
      setCurrentDropdownStatus(Array.isArray(status) ? status : [status])
    );

    yield put(fetchTargetLabelsSuccess(targetLabelsRes?.data));
  }
}

function* watchFetchInitialImages() {
  yield takeEvery(FETCH_INITIAL_DATA, function* ({ payload }) {
    let { status, page, isFilter } = payload;
    const limit = yield select(selectLimit);
    const allImageIds = yield select(selectAllImgIds);
    const datasetId = yield select(selectDatasetId);
    const projectId = yield select(selectProjectId);
    const customerReview = yield select(selectCustomerReview);
    const labelId = yield select(selectLabelerId);
    const reviewerId = yield select(selectReviewerId);
    const payloadFilterTags = (yield select(selectFilterTags)).map(
      (item) => item.tag_id
    );
    const sendingStatus = Array.isArray(status) ? status.join(",") : status;

    if (page === 0 || page * limit >= allImageIds.length) {
      let sendingPayload = {
        projectId,
        offset: page * limit,
        limit,
        status: sendingStatus,
      };
      if (datasetId && JSON.parse(datasetId)) {
        sendingPayload.datasetId = JSON.parse(datasetId);
      }
      if (customerReview) {
        sendingPayload.customerReview = customerReview;
      }

      if (!isEmpty(labelId)) {
        sendingPayload.labelId = labelId;
      }

      if (!isEmpty(reviewerId)) {
        sendingPayload.reviewId = reviewerId;
      }

      if (!isEmpty(payloadFilterTags)) {
        sendingPayload.tagIds = payloadFilterTags;
      }

      const images = yield call(fetchImages, sendingPayload);

      if (isFilter) {
        yield put(resetStateImages());
      }
      if (images && images.length) {
        const newPayload = {
          images,
          status,
          page: page + 1,
          isLoadData: payload.isLoadData,
        };
        if (typeof payload.isSelectOneSourceSuccess !== "undefined") {
          newPayload.isSelectOneSourceSuccess =
            payload.isSelectOneSourceSuccess;
        }

        yield put(fetchInitialDataSuccess(newPayload));
        return;
      } else {
        yield put(selectOneSource({ id: null }));
      }
    }
  });
}

export function* watchFetchInputData() {
  yield takeEvery(FETCH_INPUT_DATA, function* ({ payload }) {
    const { status, page, isNotNextImage, isScrollDown } = payload;
    const limit = yield select(selectLimit);
    const datasetId = yield select(selectDatasetId);
    const projectId = yield select(selectProjectId);
    const customerReview = yield select(selectCustomerReview);
    const labelId = yield select(selectLabelerId);
    const reviewerId = yield select(selectReviewerId);
    const filterTags = yield select(selectFilterTags);
    const payloadFilterTags = filterTags.map((item) => item.tag_id);
    const sendingStatus = Array.isArray(status) ? status.join(",") : status;

    if (page < 0) {
      yield put(noMoreToFetch({ status, isScrollDown }));
      return;
    }

    const pagination = yield select(selectPaginationByStatus);
    if (!pagination.more && isScrollDown) {
      return;
    }

    let sendingPayload = {
      projectId,
      offset: page * limit,
      limit,
      status: sendingStatus,
      tagIds: payloadFilterTags,
    };
    if (datasetId && JSON.parse(datasetId)) {
      sendingPayload.datasetId = JSON.parse(datasetId);
    }
    if (customerReview) {
      sendingPayload.customerReview = customerReview;
    }

    if (!isEmpty(labelId)) {
      sendingPayload.labelId = labelId;
    }

    if (!isEmpty(reviewerId)) {
      sendingPayload.reviewId = reviewerId;
    }

    const images = yield call(fetchImages, sendingPayload);

    if (images && images.length) {
      yield put(
        fetchInputDataSuccess({
          images,
          status,
          page: isScrollDown ? page + 1 : page - 1,
          isNotNextImage,
          isScrollDown,
        })
      );
      return;
    }

    yield put(noMoreToFetch({ status, isScrollDown }));
  });
}

function* watchInitialFetchingData() {
  yield takeLatest(FETCH_INITIAL_DATA_SUCCESS, function* (action) {
    const allImages = yield select(selectImages);
    const orderedImages = get(action, ["payload", "images"], []);

    for (const key in allImages) {
      orderedImages.push(allImages[key]);
    }

    yield put(resetIsChangeCurrentDropdown());

    if (orderedImages.length > 0 && !action.payload.isLoadData) {
      yield put(selectOneSource({ id: orderedImages[0].sourceId }));
    }
  });
}

function* watchGetUserProject() {
  yield takeEvery(FETCH_USER_IN_PROJECT, function* ({ payload }) {
    const { projectId } = payload;
    const labelerId = getParameterByName("labeler");
    if (!isNil(JSON.parse(labelerId))) {
      yield put(setLabelerId(labelerId));
    }

    if (projectId) {
      const response = yield call(getUserInProject, { projectId });
      if (response.status) {
        const listUser = get(response, "data", {});
        yield put(fetchUserInProjectSuccess(listUser));
      }
    }
  });
}

function* watchSendEmailToSystemAdmin() {
  yield takeEvery(SEND_EMAIL_TO_SYSTEM_ADMIN, function* ({
    payload,
    callback,
  }) {
    const response = yield call(sendEmailToSystemAdminAPI, payload);
    const errorMessage = "Send Contact Email Error!";
    const errorMessageId = "notification.send-contact-email-error";
    if (response.status === 200 && response?.data?.status === true) {
      callback && callback(response);
    } else {
      yield put(
        showNotification({
          type: "error",
          msg: errorMessage,
          msgId: errorMessageId,
        })
      );
    }
  });
}

function* watchFetchDataCarCompanies() {
  yield takeLatest(FETCH_DATA_CAR_COMPANIES, function* () {
    try {
      const response = yield call(fetchDataCarCompaniesApi);
      yield put(
        fetchDataCarCompaniesSuccess(
          response.records.map((item) => ({
            value: item.carCompanyId,
            label: item.vehicleBrandName,
          }))
        )
      );
    } catch (error) {
      console.log(error);
    }
  });
}

function* watchAutoLabelRequest() {
  yield takeLatest(AUTO_LABELS_REQUEST, function* ({ payload }) {
    try {
      yield call(autoLabelApi, payload.data);
      yield put(autoLabelSuccess());
      payload.onSuccess();
      yield put(getShapes(payload.data.sourceId));
      yield put(
        showNotification({
          type: "success",
          msg: "Auto label successfully.",
          msgId: "notification.auto-label-success",
        })
      );
    } catch (error) {
      yield put(autoLabelFailure());
      yield put(
        showNotification({
          type: "error",
          msg: "Auto label failed!",
          msgId: "notification.auto-label-failed",
        })
      );
    }
  });
}

function* watchGetAuditLogs() {
  yield takeLatest(GET_AUDIT_LOGS, function* (action) {
    const { imageId } = action.payload || {};
    const response = yield call(getAuditLogsAPI, imageId);
    if (response.success) {
      yield put(getAuditLogsSuccess(response.data));
    } else {
      yield put(getAuditLogsError({ msg: "Get audit logs error!" }));
    }
  });
}

export default function* app() {
  yield all([
    fork(watchFetchInputAndSelectOne),
    fork(watchInitialFetchingData),
    fork(watchLoadAppInfo),
    fork(watchFetchInitialImages),
    fork(watchUserData),
    fork(watchGetModuleCode),
    fork(watchFetchInputData),
    fork(watchGetUserProject),
    fork(watchSendEmailToSystemAdmin),
    fork(watchFetchDataCarCompanies),
    fork(watchAutoLabelRequest),
    fork(watchGetAuditLogs),
  ]);
}
